var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddMenuSelected = function SvgAddMenuSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007AFF",
    fillRule: "evenodd",
    d: "M9.6 18a9 9 0 1 0 0-18 9 9 0 0 0 0 18M5.717 9.52A.7.7 0 0 1 5.505 9q0-.336.203-.538a.75.75 0 0 1 .556-.212h2.594V5.656q0-.336.203-.547a.7.7 0 0 1 .52-.212q.336 0 .54.212.21.202.21.547V8.25h2.604q.335 0 .538.212a.71.71 0 0 1 .212.538.7.7 0 0 1-.212.52.73.73 0 0 1-.538.204h-2.603v2.602a.74.74 0 0 1-.212.547.73.73 0 0 1-.538.204.7.7 0 0 1-.52-.203.76.76 0 0 1-.204-.548V9.724H6.264a.76.76 0 0 1-.547-.203",
    clipRule: "evenodd"
  })));
};
export default SvgAddMenuSelected;